import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OnboardingProcessState } from 'src/app/models/state/onboarding-process-state.model';

export const selectOnboardingProcessState =
	createFeatureSelector<OnboardingProcessState>('onboardingProcess');

export const selectPathFor = (stepNumber: number, stepRouteNumber: number) =>
	createSelector(
		selectOnboardingProcessState,
		(onboardingProcessState: OnboardingProcessState) => {
			if (onboardingProcessState.onboardingProgress.length === 0) {
				return null;
			}
			const onboardingProcess = onboardingProcessState.onboardingProgress.find(
				stepProcess => stepProcess.stepNumber === stepNumber
			);

			if (
				!onboardingProcess ||
				onboardingProcess.stepRoutesProgress?.length === 0
			) {
				return null;
			}

			const stepRouteProcess = onboardingProcess.stepRoutesProgress.find(
				stepRoute => stepRoute.stepRouteNumber === stepRouteNumber
			);

			return stepRouteProcess?.route ?? null;
		}
	);

export const selectIsThereNextStepRoute = createSelector(
	selectOnboardingProcessState,
	(onboardingProcessState: OnboardingProcessState) => {
		return onboardingProcessState.nextProcess !== null;
	}
);

export const selectIsTherePreviousStepRoute = createSelector(
	selectOnboardingProcessState,
	(onboardingProcessState: OnboardingProcessState) => {
		return onboardingProcessState.previousProcess !== null;
	}
);

export const selectCanCurrentStepRouteProcessGoBack = createSelector(
	selectOnboardingProcessState,
	(onboardingProcessState: OnboardingProcessState) => {
		const { currentProcess } = onboardingProcessState;
		return onboardingProcessState.onboardingProgress
			.find(stepProcess => stepProcess.stepNumber === currentProcess.stepNumber)
			?.stepRoutesProgress.find(
				stepRoute =>
					stepRoute.stepRouteNumber === currentProcess.stepRouteNumber
			)?.canGoBack;
	}
);

export const selectCurrentProcess = createSelector(
	selectOnboardingProcessState,
	(onboardingProcessState: OnboardingProcessState) => {
		return onboardingProcessState.currentProcess;
	}
);

export const selectIsOnboardingProgressEmpty = createSelector(
	selectOnboardingProcessState,
	(onboardingProcessState: OnboardingProcessState) => {
		return onboardingProcessState.onboardingProgress.length === 0;
	}
);

export const selectCurrentProcessInfo = createSelector(
	selectOnboardingProcessState,
	(onboardingProcessState: OnboardingProcessState) => {
		if (onboardingProcessState.onboardingProgress.length === 0) {
			return {
				currentStepNumber: 0,
				currentStepRouteNumber: 0,
				totalSteps: 0,
				currentRoute: 'loading',
			};
		}

		const { stepNumber, stepRouteNumber } =
			onboardingProcessState.currentProcess;
		const currentStepRoute = onboardingProcessState.onboardingProgress
			.find(process => process.stepNumber === stepNumber)
			.stepRoutesProgress.find(
				stepRoute => stepRoute.stepRouteNumber === stepRouteNumber
			);
		return {
			currentStepNumber: stepNumber,
			currentStepRouteNumber: stepRouteNumber,
			totalSteps: onboardingProcessState.totalSteps,
			currentRoute: currentStepRoute.route,
			currentRouteName: currentStepRoute.routeName,
		};
	}
);
